/**
 * @description Fonction pour slider Touch homepage 
 * @param root {string}
 * @param masonryDisplay {boolean}
 * @constructor
 */

const fingerSlide = (root, masonryDisplay) => {

  //constantes

  const $ = {
    root: root,
    slides: ` ${root}__slide`,
    dataSlide: `data-slide`
  }

  // Variables

  let startX,
    endX,
    startY,
    endY,
    dist,
    distY,
    distMinleft = -75,
    distMinRight = 75,
    dragging = false,
    count = 3

  let bsBreakpoint = bsBreakpoints.detectBreakpoint();


  /**
* @description Fonction pour retourner le nb de slides
*/
  const nbSlides = () => {
    return document.querySelectorAll(`${$.slides}`).length;
  }

  /**
* @description Fonction pour initialiser les numéros de slides et le premier slide
*/
  const setSlider = () => {
    document.querySelectorAll(`${$.slides}`).forEach((slide, index) => {
      slide.setAttribute('data-slide', index + 1);
      if (index === 0) {
        slide.classList.add('slide-active')
      }

      // Ajout data attribute pour lun effet masonry (exemple:  social wall lambersart)

      if (masonryDisplay) { // On ajoute une classe sur les 3 derniers elements
        if (index === nbSlides || index === (nbSlides - 1) || index === (nbSlides - 2)) {
          slide.classList.add('last-slide')
        }
        const dataSlide = slide.getAttribute('data-slide');
        // On check les elements pour appliquer une classe a chaque trio d'elements
        let tier = (index + 1) % 3;
        // On set un data atrribute pour avoir un multiplicateur (utilisé par le translate)  sur les multiples de 3 et on  augmente le compteur
        if (tier === 0) {
          slide.setAttribute('data-row', count / 3)
          count = count + 3;
        }
        // On set un data atrribute pour avoir un multiplicateur (utilisé par le translate)  sur les éléments précedant le  mutliple de 3 
        else if (dataSlide <= count) {
          if (tier != 0) {
            slide.setAttribute('data-row', count / 3)
          }
        }
      }
    })
  }



  /**
* @description Fonction de gestion des translate des slides
* @param target {node} 
* @param direction {string} 
* @param currentSlide {number} 
*/
  const translate = (target, direction, currentSlide, currentSlideWidth) => {

    if (masonryDisplay && bsBreakpoint === "small") {
      if (direction === "left") {
        if (target.classList.contains('last-slide') && currentSlide > 2) { //Si + de 2 trio de slides on applique le mutliplicateur
          target.style.transform = `translateX(-${currentSlideWidth * currentSlide}px)`;
        }
        else { // Si 2 trio de slides ou moins, pas de multiplicateur
          target.style.transform = `translateX(-${currentSlideWidth}px)`;
        }
      }
      else if (direction === 'right') {
        target.style.transform = `translateX(${currentSlideWidth - currentSlideWidth}px)`;
      }
    }
    else { // comportement classique
      let slideWidth = currentSlideWidth + 24;
      let calculate = (slideWidth * currentSlide) - ((slideWidth * 2));
      if (direction === "left") {
        target.style.transform = `translateX(-${slideWidth * currentSlide}px)`;
      }
      else if (direction === 'right') {
        target.style.transform = `translateX(-${calculate}px)`;
      }
    }
  }


  /**
* @description Fonction de detection d'un swipe vertical
  * @param start {number} valeur de la difference entre start et end
   * @param slideHeight {number} hauteur de la slide, pour appliquer un scroll 
*/

const swipeVertical = (distY, posNew, end) => {
  let position = window. pageYOffset;
  let posEnd = end || position - distY;
  let newPos;
 
  if (distY > 0 ){ // tu monte
    newPos = posNew || position - 10;

    if ( newPos > posEnd ) {

      setTimeout(function() {
        window.scrollTo(0, newPos);
        newPos -= 10;
        swipeVertical(distY, newPos, posEnd)
      }, 10)

    }

  }
  else if (distY < 0){ // tu descent
    newPos = posNew || position + 10;

    if ( newPos < posEnd ) {

      setTimeout(function() {
        window.scrollTo(0, newPos);
        newPos += 10;
        swipeVertical(distY, newPos, posEnd)
      }, 10)

    }
  }
}

  /**
* @description Fonction de detection de la direction du swipe
  * @param start {number} horizontal touch position start
   * @param end {number} horizontal touch position end
   * @param slideNumber {number} slide touched
*/

  const swiperDirection = (start, end, slideNumber, currentSlideWidth) => {
    document.querySelectorAll(`${$.slides}`).forEach((slide, index) => {
      if (start > end && slideNumber < nbSlides()) {    // slide a gauche && prevent slide left si last slide
        translate(slide, "left", slideNumber, currentSlideWidth);
      }
      else {   //slide a droite
        if (slideNumber > 1) {    //prevent slide right si first slide
          translate(slide, "right", slideNumber, currentSlideWidth);
        }
      }
    })
  }

  /**
  * @description Fonction de detection du touch
  */
  const detectSlider = () => {
    if(bsBreakpoint === "xSmall" || bsBreakpoint === "small" || bsBreakpoint === "medium"){
      document.querySelectorAll(`${$.slides}`).forEach(slide => {
        slide.addEventListener('touchstart', slideStart);
        slide.addEventListener('touchmove', slideMove);
        slide.addEventListener('touchend', slideEnd);
      })
    }
  }

  /**
  * @description fonction start touch
  */
  const slideStart = (e) => {
    var touchobj = e.changedTouches[0];
    dist = 0;
    startX = touchobj.pageX;
    startY = touchobj.pageY;
  }

  /**
  * @description fonction   touch move
  */
  const slideMove = (e) => {
    if (e.cancelable) {
      e.preventDefault();
      dragging = true;
    }
  }

  /**
  * @description fonction   end touch
  */
  const slideEnd = (e) => {
    if (dragging) {
      var touchobj = e.changedTouches[0];
      endX = touchobj.pageX;
      endY = touchobj.pageY;
      dist = endX - startX;
      distY = endY - startY;
      let slideNumb = e.currentTarget.getAttribute('data-slide');
      let slideWidth = e.currentTarget.scrollWidth;
      let target = e.currentTarget;
      if(distY > 50 || distY < -50){
        swipeVertical(distY);
      } else {
        if (dist <= distMinleft || dist >= distMinRight) {
          swiperDirection(startX, endX, slideNumb, slideWidth);
        }
      }
      
      if (masonryDisplay) {
        if (bsBreakpoint === "small") {
          let slideRow = e.currentTarget.getAttribute('data-row');
          let target = e.currentTarget;
          const slides = document.querySelectorAll(`${$.slides}`);
          let slideWidth = slides[0].scrollWidth + slides[1].scrollWidth + 48;
          if (dist <= distMinleft || dist >= distMinRight) {
            swiperDirection(startX, endX, slideRow, slideWidth, target);
          }
        }
      }
      return true;
    }
  }
  /**
  * @description fonction de génération du slider
  */
  const generate = () => {
    if (bsBreakpoint === "small" || bsBreakpoint === "xSmall" ) {
      setSlider();
      detectSlider();
      
    }
    else { // On désactive le translate sur desktop
      document.querySelectorAll(`${$.slides}`).forEach(slide => {
        slide.style.transform = ""
      })
    }
  }
  generate();
  window.addEventListener('resize', () => {
    bsBreakpoint = bsBreakpoints.detectBreakpoint();
    generate();
  })
}
